export default __webpack_public_path__ + "static/media/closeCard.fef1834a.svg";